/* eslint-disable */

import React, { useEffect } from 'react';
import { Typography, Button, Card, CardContent, Stack, Divider } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PrintIcon from '@mui/icons-material/Print';
import { viewAEPSpaymentRecieptApi } from 'utils/API/Merchant APIs/AepsApiCalls';
import { handleCatchError } from 'utils/CatchHandler';
import { getDomainImage } from 'utils/API/Merchant APIs/AuthApiCalls';
import Acemoneylogo from '../../../../assets/images/ACE_MONEY_MASTER_LOGO0.png';
import Receipt from './Receipt';
import { paymentReceiptApi } from 'utils/API/Merchant APIs/UpdatedAPIs/AEPSUpdatedApiCall';

const TransactionSuccessCard = ({ responseData, tabIndex, ServiceType }) => {
    const [recieptLoading, setRecieptLoading] = React.useState(false);
    const [receiptHtml, setReceiptHtml] = React.useState('');
    const [url, setURL] = React.useState('');
    const [openReceipt, setOpenReceipt] = React.useState(false);

    const amount = tabIndex === 0 || tabIndex === 3 ? responseData?.amount || 0 : responseData?.balanceAmount || 0;

    const referenceId = tabIndex === 0 || tabIndex === 3 ? responseData?.txnId : responseData?.fpTransactionId || responseData?.txnId;

    useEffect(() => {
        const domainName = window.location.protocol + '//' + window.location.hostname;
        if (
            domainName === 'https://dev-app.acemoney.in' ||
            domainName === 'http://localhost' ||
            domainName === 'https://app.acemoney.in' ||
            domainName === 'https://stage-app.acemoney.in' ||
            domainName === 'https://api-user.acemoney.in'
        ) {
            setURL(Acemoneylogo);
        } else {
            logoFromDomainName(domainName);
        }
    }, []);

    const logoFromDomainName = async (domain) => {
        try {
            const payload = { domain };
            const response = await getDomainImage(payload);
            const logoURL = response?.data?.image_url;
            if (logoURL) {
                setURL(logoURL);
            } else {
                setURL(Acemoneylogo);
            }
        } catch (error) {
            console.log(error);
            handleCatchError(error);
        }
    };

    const recieptPage = async () => {
        try {
            setRecieptLoading(true);
            let id;
            // if (service === 'cash') {
            //     id = details.bank_RRN || details?.refid;
            // } else {
            id = responseData.bankRrn?.replace(/\nPvBal:[\d.]+/, '') || responseData?.bankRRN?.replace(/\nPvBal:[\d.]+/, '');
            // }
            const image = url;
            let type;
            if (ServiceType == 'fino') {
                type = ServiceType === 'fino' ? 'fino' : 'finpay';
            } else {
                type = ServiceType;
            }
            const payload = { id, image, type };
            const response = await paymentReceiptApi(payload);
            setReceiptHtml(response?.data?.data?.html || '');
            setOpenReceipt(true);
        } catch (e) {
            console.log(e.message);
            handleCatchError(e);
        } finally {
            setRecieptLoading(false);
        }
    };

    const handleDownload = async () => {
        await recieptPage();
    };

    const handleClose = () => {
        setOpenReceipt(false);
    };

    return (
        <Card
            sx={{
                maxWidth: 455,
                textAlign: 'center',
                padding: 2,
                borderRadius: 3,
                boxShadow: 3,
                mx: 'auto'
            }}
        >
            <CardContent>
                <CheckCircleOutlineIcon sx={{ color: '#4caf50', fontSize: 50, mb: 1 }} />
                <Typography variant="h6" sx={{ color: '#357A38' }}>
                    Transaction Successful
                </Typography>

                <Typography variant="h4" sx={{ fontWeight: 'bold', my: 2, color: '#001F54' }}>
                    ₹{amount.toLocaleString('en-IN')}/-
                </Typography>

                <Typography variant="subtitle2" color="text.secondary">
                    Transaction ID
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        mb: 2,
                        fontWeight: 500,
                        letterSpacing: 1,
                        color: '#001F54'
                    }}
                >
                    {referenceId}
                </Typography>

                <Divider sx={{ mb: 2 }} />

                <Stack spacing={1.5}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        startIcon={<PrintIcon />}
                        onClick={handleDownload}
                        disabled={recieptLoading}
                    >
                        {recieptLoading ? 'Preparing Receipt...' : 'View Receipt'}
                    </Button>
                    {receiptHtml && <Receipt receiptHtml={receiptHtml} openReceipt={openReceipt} handleClose={handleClose} />}
                </Stack>
            </CardContent>
        </Card>
    );
};

export default TransactionSuccessCard;
